import { TimeRangeOption, TimeRangeSelection, TimeRangeUnit } from '@/types';

export const CUSTOM_TIME_RANGE_KEY = 'custom';

export const DEFAULT_TIME_RANGE_OPTIONS: TimeRangeOption[] = [
    { value: 24, unit: 'hours' },
    { value: 7, unit: 'days' },
    { value: 30, unit: 'days' },
];

export function isCustomTimeRange(
    selection: TimeRangeSelection
): selection is typeof CUSTOM_TIME_RANGE_KEY {
    return selection === CUSTOM_TIME_RANGE_KEY;
}

export function timeRangeUnitMessageKey(unit: TimeRangeUnit): string {
    const messageKeys: Record<TimeRangeUnit, string> = {
        hours: 'general.hour',
        days: 'general.days',
        months: 'general.month',
    };

    return messageKeys[unit];
}

export function dateFromTimeRange(value: number, unit: TimeRangeUnit, now = new Date()): Date {
    const from = new Date(now);

    switch (unit) {
        case 'hours':
            from.setHours(from.getHours() - value);
            break;
        case 'days':
            from.setDate(from.getDate() - value);
            break;
        case 'months':
            from.setMonth(from.getMonth() - value);
            break;
    }

    return from;
}
